import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Function to set language attributes
const setLanguageAttributes = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  const savedLanguage = localStorage.getItem('preferredLanguage');
  const domain = window.location.hostname;
  
  // Determine which language to use
  let language = 'en'; // Default
  
  if (langParam && (langParam === 'el' || langParam === 'en')) {
    language = langParam;
  } else if (savedLanguage && (savedLanguage === 'el' || savedLanguage === 'en')) {
    language = savedLanguage;
  } else if (domain.endsWith('.gr')) {
    language = 'el';
  }
  
  // Set HTML lang attribute
  document.documentElement.lang = language;
  
  // Add language-specific font adjustments
  if (language === 'el') {
    document.body.classList.add('greek-text');
  }
};

// Create a simple favicon with the first letter of the domain
const createDynamicFavicon = () => {
  const domain = window.location.hostname;
  
  // For localhost or development, use URL parameters if available
  let displayDomain = domain;
  if (domain === 'localhost' || domain.includes('127.0.0.1')) {
    const urlParams = new URLSearchParams(window.location.search);
    const testDomain = urlParams.get('domain');
    if (testDomain) {
      displayDomain = testDomain;
    }
  }
  
  const firstLetter = displayDomain.charAt(0).toUpperCase();
  return firstLetter;
};

// Set language attributes before rendering
setLanguageAttributes();

// Create root and render app
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);